import { useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion } from 'motion/react';

import { useGetParams } from './hooks/useGetParams';
import { useVote } from './hooks/useVote';
import { useWordCloud } from 'hooks/useWordCloud';

import { QrCodes, Title, WordCloud } from './components';

import defaultBackground from './assets/images/bg.webp';
import styles from './App.module.css';

const WORDCLOUD = 'S1';
const WORDCLOUD_WIN = 'S2';
const VISIBLE_WORDCLOUD = [WORDCLOUD, WORDCLOUD_WIN];

function App() {
  const { bg, bgColor } = useGetParams();
  const { currentState, voteState, isVisible, idVote } = useVote();
  const { options, winWord, wordsInTitre } = useWordCloud({
    voteState,
    idVote,
    currentState,
  });

  const wordcloudRef = useRef(null);
  const [visible, setVisible] = useState(false);

  // задержка для анимации анонса
  useEffect(() => {
    let timer = '';

    if (!currentState) {
      setVisible(false);
    } else {
      timer = setTimeout(() => setVisible(true), 2300);
    }
    return () => {
      clearTimeout(timer);
    };
  }, [currentState]);

  // задержка для анимации появления слов
  useEffect(() => {
    if (!visible) {
      return;
    }
    const timer = setTimeout(() => {
      const container = wordcloudRef.current;

      if (!container) return;
      const textNodes = container.querySelectorAll('text');

      for (const element of textNodes) {
        if (currentState === WORDCLOUD_WIN) {
          if (element.textContent === winWord?.text) {
            element.classList.add(styles.isWinWord);
          } else {
            element.classList.add(styles.isLoserWord);
          }
        } else {
          element.classList.remove(styles.isWinWord, styles.isLoserWord);
        }
      }
    }, 600);

    return () => clearTimeout(timer);
  }, [currentState, winWord, visible]);

  const background =
    bg && bg !== '0'
      ? `url(${bg === '1' ? defaultBackground : bg}) center/cover no-repeat, ${bgColor}`
      : `none, ${bgColor}`;

  return (
    <div className={styles.appWrapper} style={{ background }}>
      <div
        className={styles.appBlur}
        style={{ backdropFilter: currentState && 'blur(10rem)' }}
      >
        <AnimatePresence mode="wait">
          {currentState && (
            <motion.div
              key="TITLE"
              exit={{ opacity: 0 }}
              transition={{ duration: 0.5 }}
            >
              <Title />
            </motion.div>
          )}
        </AnimatePresence>

        <div className={styles.qrAndMessages}>
          <div className={styles.qrsWrapper}>
            <AnimatePresence mode="wait">
              {currentState && (
                <motion.div
                  className={styles.motionWrap}
                  key="QRS"
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.5 }}
                >
                  <QrCodes />
                </motion.div>
              )}
            </AnimatePresence>
          </div>

          <div className={styles.messagesWrap} ref={wordcloudRef}>
            <AnimatePresence mode="wait">
              {VISIBLE_WORDCLOUD.includes(currentState) && visible && (
                <motion.div
                  className={styles.motionWords}
                  key="WORDCLOUD"
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.5 }}
                >
                  <WordCloud
                    options={options}
                    wordsInTitre={wordsInTitre}
                    currentState={currentState}
                  />
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
